import classNames from 'classnames';

import { SectionTitle } from '@/ui/index';

import Service from './Service';

import styles from './ServicesGrid.module.scss';

const ServicesGrid = ({ data }) => {
  return (
    <>
      {data?.sections?.map((item, index) => {
        return (
          <div
            className={'wrapper section'}
            key={index}
            itemScope
            itemType='https://schema.org/Service'
          >
            <SectionTitle icon={item?.icon} titleModify='title--large'>
              {item?.title}
            </SectionTitle>

            <div
              className={classNames([
                styles.grid,
                {
                  [styles.baseGrid]: item?.cards?.length === 3,
                  [styles.row]:
                    !(item?.cards?.length % 2) && item?.cards?.length <= 4,
                  [styles.mix]: item?.cards?.length > 4,
                },
              ])}
            >
              {item?.cards?.map((element, index) => (
                <Service
                  key={index}
                  item={element}
                  popular={item?.color === 'gray'}
                />
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ServicesGrid;
